<template>
  <v-app v-if="isOnMaintenance">
    <OnMaintenance :seconds="31" />
  </v-app>
  <v-app v-else>
    <FeedbackProgress />
    <FeedbackDialog />
    <FeedbackSnack />
    <BetDialog />
    <VariableCommission />
    <router-view />
  </v-app>
</template>
<script>
import FeedbackProgress from "@/components/common/feedback/FeedbackProgress";
import FeedbackDialog from "@/components/common/feedback/FeedbackDialog";
import FeedbackSnack from "@/components/common/feedback/FeedbackSnack";
import BetDialog from "@/components/common/bet/BetDialog";
import VariableCommission from "@/components/common/dialog/VariableCommission";
import OnMaintenance from "./OnMaintenance";

export default {
  name: "App",
  components: {
    FeedbackProgress,
    FeedbackDialog,
    FeedbackSnack,
    BetDialog,
    OnMaintenance,
    VariableCommission,
  },
  data: () => ({
    isOnMaintenance: false,
  }),
  computed: {
    counterOfErrors500() {
      return this.$store.getters.getCounterOfErrors500;
    },
  },
  watch: {
    counterOfErrors500() {
      if (this.counterOfErrors500 >= 5) {
        localStorage.setItem("blockAfterReload", JSON.stringify(true));
        this.isOnMaintenance = true;
        setTimeout(() => {
          localStorage.setItem("blockAfterReload", JSON.stringify(false));
        }, 30000);
      }
    },
  },
  mounted() {
    if (this.isOnMaintenance) {
      return;
    }

    const blockAfterReload = JSON.parse(
      localStorage.getItem("blockAfterReload")
    );

    if (blockAfterReload) {
      this.$store.commit("resetCounterOfErrors500");

      setTimeout(() => {
        localStorage.setItem("blockAfterReload", JSON.stringify(false));
      }, 30000);

      this.isOnMaintenance = true;
    } else {
      this.isOnMaintenance = false;
    }

    fetch("https://api.ipify.org?format=json")
      .then((x) => x.json())
      .then(({ ip }) => {
        this.$axios.defaults.headers.ip = ip;
      });
  },
};
</script>
